// extracted by mini-css-extract-plugin
export default {"alertIconContent":"ExternalPartScreen_alertIconContent__NZAPT","form":"ExternalPartScreen_form__UW8Q3","tabContainer":"ExternalPartScreen_tabContainer__GO1h1"};